import { ModuleConfig } from '@/core/module';
import { collateralRoutes } from './routes';
import { useCollateralStore } from './stores/collateral-store';

export { useCollateralStore } from './stores/collateral-store';
export {
    useCollateralSearch,
    useCollateralDetail,
    useLoanCollateralLinks,
    useCollateralMutations,
    useLoanCollateralLinkMutations,
} from './hooks/useCollaterals';
export { default as LoanCollateralLinksPanel } from './components/LoanCollateralLinksPanel';
export { default as CollateralCard } from './components/CollateralCard';
export { default as CollateralForm } from './components/CollateralForm';
export { default as CollateralDocumentUpload } from './components/CollateralDocumentUpload';
export * from './types/collateral.types';

export const CollateralManagementModule: ModuleConfig = {
    name: 'collateral-management',
    displayName: 'Collateral Management',
    description:
        'Register, update and attach supporting documents to branch-scoped collaterals, and pledge them to loans.',
    routes: collateralRoutes,
    stores: {
        collateral: useCollateralStore,
    },
    permissions: ['00702'],
    initialize: () => {
        console.log('Collateral Management module initialized');
    },
};
